export const MANUAL_SALE_CUTOFF_DATE = "2026-10-01";
export const MANUAL_SALE_CUTOFF_NOTICE = "A partir de 01/10, registre a venda no LIFT. Ela cai aqui sozinha.";
export const MANUAL_SALE_TIME_ZONE = "America/Sao_Paulo";

export function saoPauloDateKey(value = new Date()) {
  if (typeof value === "string") {
    const dateOnly = value.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (dateOnly) return dateOnly[1];
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone:MANUAL_SALE_TIME_ZONE,
    year:"numeric",
    month:"2-digit",
    day:"2-digit",
  }).formatToParts(date);
  const part = type => parts.find(item => item.type === type)?.value || "";
  return `${part("year")}-${part("month")}-${part("day")}`;
}

export function isManualSaleCutoffActive(now = new Date()) {
  const localDay = saoPauloDateKey(now);
  return Boolean(localDay && localDay >= MANUAL_SALE_CUTOFF_DATE);
}

export function canManuallyRegisterSale(user, now = new Date()) {
  return !isManualSaleCutoffActive(now) || ["admin", "superadmin"].includes(user?.role);
}

export function manualSaleWriteDenied({
  user,
  now = new Date(),
  previousStage,
  nextStage,
  saleStages = [],
  creatingSale = false,
} = {}) {
  if (canManuallyRegisterSale(user, now)) return false;
  if (creatingSale) return true;
  return saleStages.includes(nextStage) && !saleStages.includes(previousStage);
}